import { wait } from "@testing-library/user-event/dist/utils";
import MQTT from "precompiled-mqtt";
import { createContext, useContext, useEffect, useState } from "react";


const WebSocketContext = createContext()


export const WebSocketProvider = ({ children }) => {
    const [connectionStatus, setConnectStatus] = useState("Not connected");
    const [client, setClient] = useState(null);
    const [subscriptions, setSubscriptions] = useState({}); // Gestisce i callback per ogni topic

    const mqttConnect = (host) => {
        console.log("WS trying to connect to " + host);
        setClient(MQTT.connect(host));
    };

    const mqttMatch = (subscribedTopic, receivedTopic) => {
        const subParts = subscribedTopic.split("/");
        const recvParts = receivedTopic.split("/");
    
        for (let i = 0; i < subParts.length; i++) {
            if (subParts[i] === "#") return true; // `#` cattura tutto il resto
            if (subParts[i] === "+") continue; // `+` è un wildcard per un singolo livello
            if (subParts[i] !== recvParts[i]) return false;
        }
    
        return subParts.length === recvParts.length;
    };

    useEffect(() => {
        if (client) {
            client.on("connect", () => {
                setConnectStatus("Connected");
            });

            client.on("message", (topic, message) => {
                try {
                    const payload = {
                        topic,
                        message: JSON.parse(message.toString()),
                        time: new Date().getTime(),
                    };
            
                    console.log(`📩 Messaggio ricevuto su ${topic}:`, payload);
            
                    setSubscriptions((prev) => {
                        Object.keys(prev).forEach((subscribedTopic) => {
                            if (mqttMatch(subscribedTopic, topic)) {
                                prev[subscribedTopic].forEach((callback) => callback(payload));
                            }
                        });
                        return prev;
                    });
                } catch (err) {
                    console.error(`⚠️ Errore nel parsing del messaggio su ${topic}:`, err);
                }
            });
        } else {
            mqttConnect(process.env.REACT_APP_WS_URL);
        }
    }, [client]);

    const subscribe = (topic, callback) => {
        setSubscriptions((prev) => {
            const updated = { ...prev, [topic]: [...(prev[topic] || []), callback] };
            console.log("✅ Sottoscrizione aggiornata:", updated);
            return updated;
        });

        if (client) {
            client.subscribe(topic, (err) => {
                if (!err) console.log(`📡 Sottoscritto a ${topic}`);
                else console.error(`❌ Errore nella sottoscrizione a ${topic}:`, err);
            });
        }
    };

    const unsubscribe = (topic, callback) => {
        setSubscriptions((prev) => {
            if (!prev[topic]) return prev;

            const updatedCallbacks = prev[topic].filter((cb) => cb !== callback);
            const updated = updatedCallbacks.length > 0
                ? { ...prev, [topic]: updatedCallbacks }
                : (() => {
                    const newSubs = { ...prev };
                    delete newSubs[topic];
                    return newSubs;
                })();

            console.log("🛑 Sottoscrizione aggiornata dopo unsubscribe:", updated);

            if (updatedCallbacks.length === 0 && client) {
                client.unsubscribe(topic, () => {
                    console.log(`❎ Unsubscribed from ${topic}`);
                });
            }

            return updated;
        });
    };

    return (
        <WebSocketContext.Provider value={{ connectionStatus, client, subscribe, unsubscribe }}>
            {children}
        </WebSocketContext.Provider>
    );
};

export const useWebSocket = () => {
    const webSocketContext = useContext(WebSocketContext)
    const { connectionStatus, client, subscribe, unsubscribe } = webSocketContext
    return { connectionStatus, client, subscribe, unsubscribe }
}